import React from "react";

export const WVE_URL = "https://www.weddingvideo.co.uk/";

export function WVELink({ children = "Wedding Video Essex", className = "" }) {
  return (
    <a
      href={WVE_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="wve-link"
      className={`underline decoration-bde-pink decoration-2 underline-offset-4 hover:text-bde-pink transition-colors ${className}`}
    >
      {children}
    </a>
  );
}

// Render a string and replace the substring "Wedding Video Essex"
// with a <WVELink>. Returns an array of React nodes safe to render as children.
export function withWVELink(text) {
  if (!text) return text;
  const parts = text.split(/(Wedding Video Essex)/g);
  return parts.map((p, i) =>
    p === "Wedding Video Essex" ? <WVELink key={i}>{p}</WVELink> : <React.Fragment key={i}>{p}</React.Fragment>
  );
}
